import React, { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const OTHER = "__other__";

export const CityPicker = ({ value, onChange, cities, testid = "city-picker", className = "h-10", placeholder = "Ville" }) => {
  const isKnown = !value || cities.includes(value);
  const [other, setOther] = useState(!isKnown);
  const selectValue = other ? OTHER : value;

  const handleSelect = (v) => {
    if (v === OTHER) { setOther(true); onChange(""); } else { setOther(false); onChange(v); }
  };

  return (
    <div className="space-y-2">
      <Select value={selectValue} onValueChange={handleSelect}>
        <SelectTrigger data-testid={testid} className={className}><SelectValue placeholder={placeholder} /></SelectTrigger>
        <SelectContent>
          {cities.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          <SelectItem value={OTHER} data-testid={`${testid}-other`}>Autre ville…</SelectItem>
        </SelectContent>
      </Select>
      {other && (
        <input
          autoFocus
          required
          placeholder="Saisissez votre ville (ex : Meknès)"
          data-testid={`${testid}-input`}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={`${className} w-full rounded-md border border-input px-3 text-sm`}
        />
      )}
    </div>
  );
};
